module.exports = __webpack_public_path__ + "static/preferred-schools-header-1faeb0772db610d39a865a3aa0d4cf9a.jpg";